/**
 * Created by zhaoyao on 19:45.
 * 充值详情界面
 */
import React from 'react';
import {Divider, Button} from "antd";
import {fetchGet} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast } from "antd-mobile";

class NoDisturbing extends React.Component{

    componentWillMount() {
        document.title = "上课免打扰";
    }
    constructor(props){
        super(props);
        this.state={
            name:'NoDisturbing',
            data:{

            },
            IMEI:this.props.match.params.IMEI
        };
    }


    componentDidMount(){

    }

    render(){

        return <div className="padding_15">
                <div className="flex_row margin_top_20" style={{fontSize: '3px', color: '#3db1af'}}>
                    上课和来电说再见
                </div>
               <Divider />
                <div className="flex_row" style={{fontSize: '3px', color: '#3db1af'}}>
                    {this.state.data.assignStatus==null?("您还未添加免打扰时间段~"):("充值成功")}
                </div>
            <Divider />
            <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                                    onClick={this.onNextClick}>添加免打扰时段</Button>

        </div>
    }

    onNextClick = () => {
        const {IMEI } = this.state;
        this.props.history.push('/addNoDisturbing/'+IMEI);

    }
}

export  default NoDisturbing;